import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SvgIconService } from './svg-icon.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SvgIconComponent implements OnChanges {
  @Input() src: string = '';
  public svg!: Observable<Object>;

  constructor(public sanitizer: DomSanitizer, public svgIconService: SvgIconService) {}

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName) && propName === 'src') {
        this.initializeSVG();
      }
    }
  }

  initializeSVG() {
    const path = this.src ? this.src.replace(/\.[^/.]+$/, '') + '.svg' : '';
    this.svg = this.svgIconService.getSvg(path);
  }
}
